import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getFinancierTemplateConfig } from '@src/store/slices/insurance';
import { useDispatch } from 'react-redux'
import Pagination from '@src/common/Pagination';
import { Nav } from 'react-bootstrap';
import FullPageLoader from '@src/common/FullPageLoader';
import * as HELPER from "@src/config/helper";
import { COUNTRY_CODE, DEFAULT_PAGINATION_COUNT, PAGE_NUMBER, ROLE_FEATURES, STATUS_SUCCESS } from '@src/config/constant';
import { useLanguage } from '@src/context/LanguageContext';

const SendToFinancierTemplateListing = () => {
    let [loading, setLoading] = useState(false);
    let [templateFinancierList, setTemplateFinancierList] = useState<any>([]);

    let [paginationData, setPaginationData] = useState<any>({})
    let page = 1

    const dispatch: any = useDispatch();
    const {language,translations} = useLanguage();
    const getDetailLink = (financierData: any) => {
        const params = new URLSearchParams();
        params.set('partner_id', financierData.hashId);
        if (financierData.partner_id) {
            params.set('insurance_partner_id', financierData.partner_id);
        }
        if (financierData.insurer_id) {
            params.set('insurer_id', financierData.insurer_id);
        }
        return `/email-template-config-detail?${params.toString()}`;
    };

    // Function to fetch template financier list
    const getTemplateFinancierList = async (filters: any) => {
        // setLoading(true);
        dispatch(getFinancierTemplateConfig({...filters,language})).then((res: any) => {
            if (res?.status === STATUS_SUCCESS) {

                setTemplateFinancierList(res?.data || []);
                setPaginationData(res?.pagination ?? {})
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        });

    }

    useEffect(() => {
        setLoading(true);
        let filters = {
            page_number: PAGE_NUMBER,
            pagination: true
        }
        getTemplateFinancierList(filters);

        setPaginationData({})
        // eslint-disable-next-line
    }, [language]);

    // Function to handle pagination data requests
    const handleRequestData = (params: any) => {
        setLoading(true);
        let apiParams = {
            page_number: params.page_no
        }

        getTemplateFinancierList(apiParams);
    }
    let title ='Standalone'
    if(COUNTRY_CODE === 'id'){
        title = 'CRM'
    }


    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <div className="top-heading-outer">
                <div className="top-heading">
                    <h1> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.TMPLATE_CONFIG || translations.commonMsg?.loading}</h1>
                </div>
                <Nav variant="pills" className="flex-column tab-line nav nav-pills">
                    <Nav.Item>
                        <Nav.Link eventKey="first" active> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.INSURER || translations.commonMsg?.loading} </Nav.Link>
                    </Nav.Item>
                </Nav>
            </div>
            <div className="container-fluid">
                <div className="data-table financier-bx-table-outer">
                    <table>
                        <thead>
                            <tr>


                                {COUNTRY_CODE === 'id' ?
                                    
                                    <th style={{ width: "15%" }}> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.INSURER || translations.commonMsg?.loading}  </th>
                                    :
                                    <th style={{ width: "15%" }}>Financier</th>
                                }
                               
                                <th style={{width:"15%"}}> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.COHORT_ANALYSIS || translations.commonMsg?.loading}</th>
                                {HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['sent_to_insurance_broker'], accessType: 'isVisible' }) && <th style={{width:"25%"}}> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.SEND_TO_INSURANCE_BROKER || translations.commonMsg?.loading}  </th>}
                                {HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_policy'], accessType: 'isVisible' }) && <th style={{width:"25%"}}> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.INSURANCE_POLICY_SHARED || translations.commonMsg?.loading} </th>}
                                <th> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.STATUS || translations.commonMsg?.loading}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {templateFinancierList.map((financierData: any,index:number) => (
                                <tr key={`${financierData.partner_id}_${index}`}>
                                    {COUNTRY_CODE === 'id' ?
                                    <td>
                                        <Link
                                            to={getDetailLink(financierData)}
                                        >
                                          {financierData.insurer_name}
                                        </Link>
                                    </td>
                                    :
                                    <td>
                                        <Link
                                            to={getDetailLink(financierData)}
                                        >
                                            {financierData.partner_name}
                                        </Link>
                                    </td>
                                    }

                                    <td>
                                        <span> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.ACTIVE || translations.commonMsg?.loading} : {financierData.all_status ? financierData.all_status.split(",").filter((status: any) => +status === 1).length : 0} </span><br />
                                        <span> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.INACTIVE || translations.commonMsg?.loading} : {financierData.all_status ? financierData.all_status.split(",").filter((status: any) => +status === 0).length : 0} </span>
                                    </td>
                                    {HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['sent_to_insurance_broker'], accessType: 'isVisible' }) &&
                                        <td>
                                            <span> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.EMAIL || translations.commonMsg?.loading} : {financierData?.send_to_insurance_broker_email}
                                                {
                                                    (financierData?.send_to_insurance_broker_email_ucf || financierData?.send_to_insurance_broker_email_standalone || financierData?.send_to_insurance_broker_email_renewal)
                                                        ?
                                                        ` (${financierData?.send_to_insurance_broker_email_ucf ? "With UCF" : ""}${financierData?.send_to_insurance_broker_email_ucf && financierData?.send_to_insurance_broker_email_standalone ? ", " : ""}${financierData?.send_to_insurance_broker_email_standalone ? title : ""}${(financierData?.send_to_insurance_broker_email_ucf || financierData?.send_to_insurance_broker_email_standalone) && financierData?.send_to_insurance_broker_email_renewal ? ", " : ""}${financierData?.send_to_insurance_broker_email_renewal ? "Renewal" : ""})`
                                                        : ''
                                                }
                                            </span><br />
                                            <span> {translations.EMAIL_TEMPLATE_RULE_ENGINE?.WHATSAPP || translations.commonMsg?.loading} : {financierData?.send_to_insurance_broker_wa}
                                                {
                                                    (financierData?.send_to_insurance_broker_wa_ucf || financierData?.send_to_insurance_broker_wa_standalone || financierData?.send_to_insurance_broker_wa_renewal)
                                                        ?
                                                        ` (${financierData?.send_to_insurance_broker_wa_ucf ? "With UCF" : ""}${financierData?.send_to_insurance_broker_wa_ucf && financierData?.send_to_insurance_broker_wa_standalone ? ", " : ""}${financierData?.send_to_insurance_broker_wa_standalone ? title : ""}${(financierData?.send_to_insurance_broker_wa_ucf || financierData?.send_to_insurance_broker_wa_standalone) && financierData?.send_to_insurance_broker_wa_renewal ? ", " : ""}${financierData?.send_to_insurance_broker_wa_renewal ? "Renewal" : ""})`
                                                        : ''
                                                }
                                            </span>
                                        </td>
                                    }

                                    {HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['insurance_policy'], accessType: 'isVisible' }) &&
                                        <td>
                                            <span>{translations.EMAIL_TEMPLATE_RULE_ENGINE?.EMAIL || translations.commonMsg?.loading} : {financierData?.insurance_policy_shared_email}
                                                {
                                                    (financierData?.insurance_policy_shared_email_ucf || financierData?.insurance_policy_shared_email_standalone  || financierData?.insurance_policy_shared_email_renewal)
                                                        ?
                                                        ` (${financierData?.insurance_policy_shared_email_ucf ? "With UCF" : ""}${financierData?.insurance_policy_shared_email_ucf && financierData?.insurance_policy_shared_email_standalone ? ", " : ""}${financierData?.insurance_policy_shared_email_standalone ? title : ""}${(financierData?.insurance_policy_shared_email_ucf || financierData?.insurance_policy_shared_email_standalone) && financierData?.insurance_policy_shared_email_renewal ? ", " : ""}${financierData?.insurance_policy_shared_email_renewal ? "Renewal" : ""})`
                                                        : ''
                                                }
                                            </span><br />
                                            <span>{translations.EMAIL_TEMPLATE_RULE_ENGINE?.WHATSAPP || translations.commonMsg?.loading} : {financierData?.insurance_policy_shared_wa}
                                                {
                                                    (financierData?.insurance_policy_shared_wa_ucf || financierData?.insurance_policy_shared_wa_standalone || financierData?.insurance_policy_shared_wa_renewal)
                                                        ?
                                                        ` (${financierData?.insurance_policy_shared_wa_ucf ? "With UCF" : ""}${financierData?.insurance_policy_shared_wa_ucf && financierData?.insurance_policy_shared_wa_standalone ? ", " : ""}${financierData?.insurance_policy_shared_wa_standalone ? title : ""}
                                                        ${(financierData?.insurance_policy_shared_wa_ucf || financierData?.insurance_policy_shared_wa_standalone) && financierData?.insurance_policy_shared_wa_renewal ? ", " : ""}${financierData?.insurance_policy_shared_wa_renewal ? "Renewal" : ""})`
                                                        : ''
                                                }
                                            </span>
                                        </td>
                                    }

                                    <td>
                                        <span
                                            className={`status-${financierData?.all_status?.split(",")?.filter((status: any) => +status).length ? "active" : "inactive"
                                                }`}
                                        >
                                            {
                                            financierData?.all_status?.split(",")?.includes("1") ? "Active" : "InActive"
                                            }
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="pagination-outer">
                        {(paginationData && paginationData['total'] > DEFAULT_PAGINATION_COUNT) && <Pagination
                            paginateData={{
                                page,
                                loading: false,
                                totalLengthWithoutPagination: paginationData.total,
                                paginationData,
                                filteredData: {}
                            }}
                            sendRequestDataToParent={handleRequestData}
                        />}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default SendToFinancierTemplateListing;